import b from "../../../services/api/Boards";

export function useColumnDnD({ questId, columns, setColumns, columnOrder, setColumnOrder, alert, shareToken = "" }) {

  /** Anchor helper */
  const getAnchorsForInsert = (arr, insertIndex) => {
    const before = arr[insertIndex]?._id || arr[insertIndex]?.id || null;
    const after = arr[insertIndex - 1]?._id || arr[insertIndex - 1]?.id || null;
    return { beforeId: before, afterId: after };
  };

  const onDragEnd = async (result) => {
    const { source, destination, type } = result;
    if (!destination) return;

    /** COLUMN REORDER */
    if (type === "column") {
      const newOrder = Array.from(columnOrder);
      const [moved] = newOrder.splice(source.index, 1);
      newOrder.splice(destination.index, 0, moved);
      setColumnOrder(newOrder);
      return;
    }

    /** ---- LEAD MOVEMENT ---- */
    const startCol = columns[source.droppableId];
    const finishCol = columns[destination.droppableId];
    if (!startCol || !finishCol) return;

    const prevState = JSON.parse(JSON.stringify(columns));
    try {
      /** remove internally */
      const startItems = Array.from(startCol.items);
      const [movedLead] = startItems.splice(source.index, 1);

      /** Same column reorder */
      if (source.droppableId === destination.droppableId) {
        const beforeInsert = Array.from(startItems);
        const { beforeId, afterId } = getAnchorsForInsert(beforeInsert, destination.index);

        beforeInsert.splice(destination.index, 0, movedLead);

      setColumns({
        ...columns,
        [startCol.id]: { ...startCol, items: beforeInsert },
      });

        await b.reorderLead({
          questId,
          columnId: startCol.id,
          leadId: movedLead._id || movedLead.id,
          beforeId,
          afterId,
          shareToken,
        });
        return;
      }

      /** Cross column move */
      const finishItemsBefore = Array.from(finishCol.items);
      const { beforeId, afterId } =
        getAnchorsForInsert(finishItemsBefore, destination.index);

      const finishItems = [...finishItemsBefore];
      finishItems.splice(destination.index, 0, movedLead);

      setColumns({
        ...columns,
        [startCol.id]: {
          ...startCol,
          items: startItems,
          leadCount: Math.max(0, Number(startCol.leadCount ?? startCol.items.length) - 1),
        },
        [finishCol.id]: {
          ...finishCol,
          items: finishItems,
          leadCount: Number(finishCol.leadCount ?? finishCol.items.length) + 1,
        },
      });

      await b.moveLead({
        questId,
        leadId: movedLead._id || movedLead.id,
        fromColumnId: startCol.id,
        toColumnId: finishCol.id,
        beforeId,
        afterId,
        shareToken,
      });

    } catch (err) {
      console.error("DnD failed", err);
      setColumns(prevState);
      alert("Failed to update board layout");
    }
  };

  return { onDragEnd };
}
